const { userAgent } = window.navigator;

export const isAndroid = /android/i.test(userAgent);
export const isIOS = /iPad|iPhone|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && "standalone" in window.navigator);
export const isMobileDevice = isAndroid || isIOS;
